import moment from 'moment';

function momentFormaterISO(dateString, format = 'DD/MM/YYYY') {
  return moment.parseZone(dateString).format(format);
}

export { momentFormaterISO };
